export const getYearDateRange = (year: number) => {
  const startDate = new Date(year, 0, 1); // January 1st of the given year
  const endDate = new Date(year, 11, 31, 23, 59, 59, 999); // December 31st, 11:59:59.999 PM

  return {
    startDate,
    endDate
  };
};
